<ng-container *ngIf="projectHasIPBoards; else regularAppointment">
  <p *ngIf="showAppointmentWarning" class="italics-text">
    Omdat de oorspronkelijke plaatsing hoger dan 1 - 2 werd geplaatst, moet u
    ofwel een afspraak aanvragen of aangeven dat er een sleutel moet worden
    afgehaald
  </p>
  <adjustment-ip-board-appointment
    class="appointment-radio-list"
    [projectContacts]="projectContacts"
    [projectPlacement]="adjustment.projectPlacement"
    [client]="true"
    [disabled]="readOnly"
    (save)="emitSave()"
  ></adjustment-ip-board-appointment>
</ng-container>
<ng-template #regularAppointment>
  <div class="client-executed-form-yes-no">
    <yes-no
      [title]="'Afspraak nodig?'"
      [showExtraInstructionsOn]="'Ja'"
      [extraInstructions]="'Naam en GSM-nr contactpersoon + uur'"
      [value]="adjustment.projectPlacement.appointment"
      [inputText]="adjustment.projectPlacement.needAppointmentInfo"
      [nullIsFalse]="true"
      [nullable]="false"
      [flexRow]="false"
      [disabled]="readOnly"
      (answer)="adjustment.projectPlacement.appointment = $event; emitSave()"
      (answeredText)="
        adjustment.projectPlacement.needAppointmentInfo = $event; emitSave()
      "
    ></yes-no>
  </div>
</ng-template>
<div
  class="client-executed-form-yes-no"
  [ngClass]="adjustment.projectPlacement.collectKey ? '' : 'under-space'"
>
  <yes-no
    [title]="'Sleutel afhalen?'"
    [neverShowExtraInstructions]="true"
    [nullable]="true"
    [nullIsFalse]="true"
    [nullable]="false"
    [value]="adjustment.projectPlacement.collectKey"
    [flexRow]="false"
    [disabled]="readOnly"
    [disabledYes]="readOnly"
    [disabledNo]="readOnly"
    (answer)="adjustment.projectPlacement.collectKey = $event; emitSave()"
  ></yes-no>
  <div
    *ngIf="adjustment.projectPlacement.collectKey"
    class="left-fifteen-space align-collect-key-from w-50"
  >
    <collect-key-from-selector
      [projectPlacement]="adjustment.projectPlacement"
      [projectContacts]="projectContacts"
      (collectKeyFromChanged)="emitSave()"
    ></collect-key-from-selector>
  </div>
</div>
<div
  *ngIf="
    adjustment.projectPlacement.collectKeyFrom === -1 &&
    adjustment.projectPlacement.collectKey
  "
  class="align-collect-key-extra-info-with-selector"
>
  <textarea-input
    [placeholder]="readOnly ? '' : 'Adres noteren + openingsuren'"
    [initContent]="adjustment.projectPlacement.collectKeyExtraInfo"
    [disabled]="readOnly"
    (answer)="
      adjustment.projectPlacement.collectKeyExtraInfo = $event; emitSave()
    "
  ></textarea-input>
</div>

<div class="client-executed-form-yes-no d-flex">
  <yes-no
    [title]="'Wanneer uitvoeren ?'"
    [yesValue]="'ASAP uitvoeren'"
    [noValue]="'Op datum uitvoeren'"
    [nullIsFalse]="true"
    [nullable]="false"
    [neverShowExtraInstructions]="true"
    [value]="adjustment.projectPlacement.placeASAP"
    [flexRow]="false"
    [disabled]="readOnly"
    [disabledYes]="readOnly"
    [disabledNo]="readOnly"
    (answer)="placeASAP($event)"
  ></yes-no>

  <mat-form-field
    *ngIf="!adjustment.projectPlacement.placeASAP"
    class="next-to-checkbox-last"
    [class.date-emphasis]="
      adjustment.projectPlacement.placementEarliestDate != null
    "
    appearance="outline"
  >
    <input
      matInput
      [matDatepickerFilter]="daysFilter"
      [matDatepicker]="placementPicker"
      [disabled]="readOnly"
      [placeholder]="readOnly ? '' : 'Selecteer een datum'"
      [(ngModel)]="adjustment.projectPlacement.placementEarliestDate"
      (ngModelChange)="placementEarliestDateChange($event)"
    />
    <mat-error *ngIf="dateError">
      Datum mag niet sneller dan 3 werkdagen zijn!
    </mat-error>
    <mat-datepicker-toggle
      matSuffix
      [for]="placementPicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #placementPicker></mat-datepicker>
  </mat-form-field>
</div>
